<div class="mb-grid-container-full">
  <div class="room-information mb-grid-row"
       [class.room-information--compact]="useCompactStyle"
       [class.room-information--expanded]="hideImage"
       [class.room-information--last-room]="lastRoom"
       *ngIf="roomImage$ | async; let img">
    <div class="room-information__header mb-grid-col-4 mb-grid-col-12-dt">
      <am-room-header
        [roomName]="roomName"
        [adults]="room.adults"
        [children]="children"
        [bathrooms]="room.bathroom_total"
        [beds]="room.total_rooms"
      ></am-room-header>

      <ng-content></ng-content>

    </div>
  </div>
</div>
